<template>
    <div>
        <!-- @TODO: Add this to a reusable component -->
        <div class="text-center">
            <div class="logo-device text-center mb-6">
                <lottie-animation :loop="false" :width="180" :height="180" :path="global.app.path + 'animations/success-tick-circle.json'"/>
            </div>

            <h1 class="text-xl uppercase font-semibold mb-5">Email Verified</h1>

            <p>Your email has been verified, please <router-link :to="{name: 'login'}"> log in</router-link> to continue.</p>
        </div>
        <!-- @ENDTODO -->
    </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    name: "EmailVerifiedPage",
    components: {},
    computed: {
        ...mapGetters(["user", "global"])
    },
    data: function () {
        return {
        };
    },
    methods: {

    },
};
</script>
